import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BusinessInformation from "../../../components/customer/customer-proofile/individual-customer/BusinessInformation";
import MeansOfIdentification from "../../../components/customer/customer-proofile/individual-customer/MeansOfIdentification";
import NextOfKin from "../../../components/customer/customer-proofile/individual-customer/NextOfKin";
import ModalContainer from "../../../components/modals/ModalContainer";
import ApproveCustomer from "../../../components/modals/customers/ApproveCustomer";
import CloseCustomer from "../../../components/modals/customers/CloseCustomer";
import ReactivateCustomer from "../../../components/modals/customers/ReactivateCustomer";
import RejectCustomer from "../../../components/modals/customers/RejectCustomer";
import SelectPolicy from "../../../components/modals/customers/create/SelectPolicy";
import PageTitle from "../../../components/partials/PageTitle";
import { resetAttachedPolicyPreview } from "../../../redux/slice/policy/policySlice";
import { policyAttachmentCategories } from "../../../utils/data/constant";
import PersonalInformation from "./../../../components/customer/customer-proofile/individual-customer/PersonalInformation";
import { resetCustomerClaims } from "../../../redux/slice/customer/customerSlice";
import { resetPolicy } from "../../../redux/slice/policy/savingsPolicy/savingsPolicySlice";

const IndividualCustomerProfile = ({ single_customer, active_policy }) => {
  const [approveCustomer, setApproveCustomer] = useState();
  const [rejectCustomer, setRejectCustomer] = useState();
  const [closeCustomer, setCloseCustomer] = useState();
  const [attachPolicy, setAttachPolicy] = useState();
  const { state } = useLocation();
  const { id } = useParams();

  const dispatch = useDispatch();

  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const breadcrumb = {
    from: {
      title: "Individual Customers",
      link: "/admin/individual-customers",
    },
    current: {
      title: "Customer Profile",
      link: null,
    },
  };

  useEffect(() => {
    dispatch(resetAttachedPolicyPreview());
    dispatch(resetCustomerClaims());
    dispatch(resetPolicy());
  }, []);

  useEffect(() => {
    setApproveCustomer(
      user_permissions?.some(
        (permission) => permission.name === "approve customer"
      )
    );
    setRejectCustomer(
      user_permissions?.some(
        (permission) => permission.name === "reject customer"
      )
    );
    setCloseCustomer(
      user_permissions?.some(
        (permission) => permission.name === "close customer"
      )
    );
    setAttachPolicy(
      user_permissions?.some(
        (permission) => permission.name === "attach policy - individual"
      )
    );
  }, [user_permissions]);

  const navigate = useNavigate();

  return (
    <>
      {/* page title */}
      <PageTitle title='Customer Profile' breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            {/* {isLoading ? 
              <div className='d-flex mt-lg-5 justify-content-center align-content-center py-3'>
                <BounceLoader color='#2E3192' size={"70px"}/>
              </div> : */}
            <div className='card-body'>
              <PersonalInformation
                data={single_customer?.basic_information}
                data1={single_customer?.contact_information}
              />
              <MeansOfIdentification
                data={single_customer?.means_of_identification}
                data1={single_customer?.basic_information}
              />
              <BusinessInformation
                data={single_customer?.business_information}
                data1={single_customer?.basic_information}
              />
              <NextOfKin
                data={single_customer?.nok}
                data1={single_customer?.basic_information}
              />
              {/* <PolicyInformation status = {single_customer?.basic_information?.status} /> */}
              <div className='ro'>
                <div className='d-flex justify-content-end'>
                  <div className='d-flex me-2'>
                    {attachPolicy && single_customer?.basic_information?.status !== "4" && single_customer?.basic_information?.status !== "3"  && <button
                      className={`btn btn-primary ms-2 btn-sm mt-3 ${
                        single_customer?.basic_information?.status === "3" &&
                        "d-none"
                      }`}
                      data-bs-toggle='modal'
                      data-bs-target='#select-policy'
                    >
                      Attach Policy
                    </button>}
                    <button
                      className='btn btn-info ms-2 btn-sm mt-3'
                      onClick={() =>
                        navigate(
                          `/admin/customer-policies/${single_customer?.basic_information?.customer_id}`
                        )
                      }
                    >
                      View Policies
                    </button>
                    <button
                      className='btn btn-warning text-white ms-2 btn-sm mt-3'
                      onClick={() =>
                        navigate(
                          `/admin/customer-claims/${single_customer?.basic_information?.customer_id}`,
                          { state: id }
                        )
                      }
                    >
                      View Claims
                    </button>
                  </div>
                  {single_customer?.basic_information?.status === "1" && (
                    <div className='d-flex'>
                      {approveCustomer && (
                        <button
                          className={`btn btn-success btn-sm mt-3 px- text-white`}
                          data-bs-toggle='modal'
                          data-bs-target='#approve_customer'
                        >
                          Approve
                        </button>
                      )}
                      {rejectCustomer && (
                        <button
                          type='button'
                          className='btn btn-danger ms-2 btn-sm mt-3 px-'
                          data-bs-toggle='modal'
                          data-bs-target='#reject_customer'
                        >
                          Reject
                        </button>
                      )}
                    </div>
                  )}
                  {single_customer?.basic_information?.status === "2" &&
                    active_policy === 0 && (
                      <div className='d-flex'>
                        {closeCustomer && (
                          <button
                            type='button'
                            className={`btn btn-danger btn-sm mt-3 px- text-white`}
                            data-bs-toggle='modal'
                            data-bs-target='#close_customer'
                          >
                            Close Customer
                          </button>
                        )}
                      </div>
                    )}
                  {(single_customer?.basic_information?.status === "3" ||
                    single_customer?.basic_information?.status === "4") && (
                    <div className='d-flex'>
                      {approveCustomer && (
                        <button
                          type='button'
                          className={`btn btn-success btn-sm mt-3 px-4 text-white`}
                          data-bs-toggle='modal'
                          data-bs-target='#reactivate_customer'
                        >
                          Reactivate
                        </button>
                      )}
                    </div>
                  )}
                  <ModalContainer
                    modal_id='select-policy'
                    modal_width='modal-sm'
                  >
                    <SelectPolicy
                      state={single_customer}
                      categories={policyAttachmentCategories}
                    />
                  </ModalContainer>
                  <ModalContainer
                    modal_id='approve_customer'
                    modal_width='modal-md'
                    bradius='rounded-2'
                  >
                    <ApproveCustomer id={id} />
                  </ModalContainer>
                  <ModalContainer
                    modal_id='reject_customer'
                    modal_width='modal-md'
                    bradius='rounded-2'
                  >
                    <RejectCustomer id={id} />
                  </ModalContainer>
                  <ModalContainer
                    modal_id='close_customer'
                    modal_width='modal-md'
                    bradius='rounded-2'
                  >
                    <CloseCustomer id={id} />
                  </ModalContainer>
                  <ModalContainer
                    modal_id='reactivate_customer'
                    modal_width='modal-sm'
                    bradius='rounded-2'
                  >
                    <ReactivateCustomer id={id} />
                  </ModalContainer>
                </div>
              </div>
            </div>
            {/* } */}
          </div>
        </div>
      </div>
    </>
  );
};

export default IndividualCustomerProfile;
